import { Action, createReducer, on } from '@ngrx/store';
import { fetchAris360List, fetchAris360ListSuccess, fetchAris360ListFailure, fetchAris360Detail, fetchAris360DetailSuccess, fetchAris360DetailFailure } from './aris360.action';

export interface Aris360State {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: Aris360State = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const Aris360Reducer = createReducer(
  initialState,
  on(fetchAris360List, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchAris360ListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchAris360ListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),

  on(fetchAris360Detail, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchAris360DetailSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      detail: response
    };
  }),
  on(fetchAris360DetailFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: Aris360State | undefined, action: Action) {
  return Aris360Reducer(state, action);
}
